import { InterestPayment } from "@letsbit/malcolmlb";
import { SWRResponse } from "swr";
import { useContext } from "react";
import { ApiContext } from "providers/ApiProvider";
import { useAuthSWR } from "hooks/utils/useAuthSWR";

export const SWR_GET_INTEREST_PAYMENTS_KEY = "get-interest-payment";

export const useGetInterestPayment = (
  tid?: string,
): SWRResponse<InterestPayment | undefined> => {
  const { memberInstance } = useContext(ApiContext);
  const swr = useAuthSWR([SWR_GET_INTEREST_PAYMENTS_KEY, tid], async () => {
    if (tid) {
      const { data } = await memberInstance.interest.getInterestPayment(tid);
      return data;
    }
    return undefined;
  });

  return swr;
};
